var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-main__inner"},[_c('div',{staticClass:"b-logo"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":_vm.logoPath,"alt":_vm.logoAlt}})])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }